import React, { useState } from 'react';
import { pdfjs } from "react-pdf";
import './About.css';

// import story from '../images/story.jpg';
// import legal from '../images/legal.jpg';
import certificate12A from '../images/12A_Certificate.pdf';
import certificate80G from '../images/80G_Certificate.pdf';
import certificateISO from '../images/ISO_Certificate.pdf';
import certificateCSR from '../images/CSR_Certificate.pdf';
import CharityCertificate from '../images/CharityCertificate.jpg';
import DarpanCertificate from '../images/DarpanCertificate.pdf';


pdfjs.GlobalWorkerOptions.workerSrc = 
  'https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.js';

const AboutLegalForDonate = () => {
  const [loadedImages, setLoadedImages] = useState(new Set());

  const handleImageLoad = (imageName) => {
    setLoadedImages(prev => new Set(prev).add(imageName));
  };

  const isImageLoaded = (imageName) => {
    return loadedImages.has(imageName);
  };

  const convertPdfToJpg = async (pdfFile, name) => {
    const loadingTask = pdfjs.getDocument(pdfFile);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1); // first page only

    const viewport = page.getViewport({ scale: 2 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: context, viewport }).promise;

    // Convert canvas to JPG
    const jpgData = canvas.toDataURL("image/jpeg");

    // Trigger download
    const link = document.createElement("a");
    link.href = jpgData;
    link.download = `${name}.jpg`; // dynamic file name
    link.click();
  };

  return (
    <>
      <div className="about-us-container">
        {/* Compliance Section */}
        <section className="compliance-section">
          <div className="section-container">
            <div className="mission-content">
              <h2>Legal & Compliance Status</h2>
              <div className='justified-text'>
                <p>
                  <strong>
                    Trust is earned—and we protect it with integrity.
                  </strong>
                </p>

                <p>
                  At Islamic Research Centre (IRC), we are deeply committed to ethical operations,
                  legal compliance, and transparent governance. Every rupee entrusted to us is
                  treated with accountability and care, and our processes reflect the trust our donors
                  and supporters place in us.
                </p>

                <li>✅ Registered NGO under the Indian Trusts Act Recognized as a legitimate
                  charitable trust, operating under legal frameworks in India.</li>
              </div>

              {/* Cards Grid */}
              <div className="compliance-cards-grid">
                {/* 12A Certified */}
                <div className="compliance-card">
                  <h3>12A Certified</h3>
                  <p>12A Certified IRC is officially recognized...</p>
                  <a
                    href={certificate12A}
                    download="12A_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>

                  <button
                    onClick={() => convertPdfToJpg(certificate12A, "12A_Certificate")}
                    className="download-certificate-btn"
                  >
                    🖼️ Download JPG
                  </button>
                </div>

                {/* 80G Certified */}
                <div className="compliance-card">
                  <h3>80G Certified</h3>
                  <p>80G Certified Donations made...</p>
                  <a
                    href={certificate80G}
                    download="80G_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>

                  <button
                    onClick={() => convertPdfToJpg(certificate80G, "80G_Certificate")}
                    className="download-certificate-btn"
                  >
                    🖼️ Download JPG
                  </button>
                </div>

                {/* ISO */}
                <div className="compliance-card">
                  <h3>ISO 9001:2015</h3>
                  <p>ISO 9001:2015 Certified...</p>
                  <a
                    href={certificateISO}
                    download="ISO_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>

                  <button
                    onClick={() => convertPdfToJpg(certificateISO, "ISO_Certificate")}
                    className="download-certificate-btn"
                  >
                    🖼️ Download JPG
                  </button>
                </div>

                {/* CSR */}
                <div className="compliance-card">
                  <h3>CSR Eligible Approved</h3>
                  <p>CSR Eligible Approved...</p>
                  <a
                    href={certificateCSR}
                    download="CSR_Certificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>

                  <button
                    onClick={() => convertPdfToJpg(certificateCSR, "CSR_Certificate")}
                    className="download-certificate-btn"
                  >
                    🖼️ Download JPG
                  </button>
                </div>

                <div className="compliance-card">
                  <h3>Charity Certificate</h3>
                  <p>Charity Certificate...</p>
                  <a
                    href={CharityCertificate}
                    download="CharityCertificate.jpg"
                    className="download-certificate-btnn"
                  >
                    📄 Download JPG
                  </a>
                </div>

                <div className="compliance-card">
                  <h3>Darpan Certificate</h3>
                  <p>Darpan Certificate...</p>
                  <a
                    href={DarpanCertificate}
                    download="DarpanCertificate.pdf"
                    className="download-certificate-btnn"
                  >
                    📄 Download PDF
                  </a>

                  <button
                    onClick={() => convertPdfToJpg(DarpanCertificate, "DarpanCertificate")}
                    className="download-certificate-btn"
                  >
                    🖼️ Download JPG
                  </button>
                </div>
              </div>
              <div className='justified-text'>
                <p>
                  <strong>
                    These credentials ensure that IRC operates with the highest standards of ethics,
                    professionalism, and transparency. They also make it easier for individuals,
                    institutions, and corporate partners to support us with confidence.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutLegalForDonate;